import { gql } from '@apollo/client';

export const PersonGroupServiceAssignmentFragment = gql`
  fragment PersonGroupServiceAssignment on PersonGroupServiceAssignment {
    groupCode
    accountCode
    serviceCode
    status
    error {
      code
      message
    }
  }
`;
